// @flow

import React, { PureComponent } from 'react';
import cx from 'classnames';
import 'client/styles/plus.scss';

type Props = {
  ariaLabel?: string | null,
  className: string,
  clickHandler: Function,
  size: string,
  style: Object,
};

class Plus extends PureComponent<Props> {
  static defaultProps = {
    ariaLabel: '',
    className: '',
    clickHandler: () => {},
    size: '2rem',
    style: {},
  };

  render() {
    const { ariaLabel, className, clickHandler, size, style } = this.props;
    return (
      <button
        aria-label={ariaLabel}
        className={cx(className, 'plus-toggle')}
        onClick={clickHandler}
        style={{
          ...style,
          fontSize: size,
        }}>
        <div className="icon-plus-circle no-margin" />
      </button>
    );
  }
}

export default Plus;
